import { Component, OnInit, Input,Output,EventEmitter, SimpleChanges, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { InvestorService } from '../investor.service'
import { NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import {Appconstants} from '../../../shared/app-constants';
import {ViewportScroller} from '@angular/common'
import {environment} from '../../../../environments/environment.prod';
import { Subject } from 'rxjs';
//import { MatCalendar, DateAdapter, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { takeUntil } from 'rxjs/operators';
import { MomentDateAdapter } from '@angular/material-moment-adapter';


 import _moment from 'moment';
 import { ActivatedRoute, Router } from '@angular/router';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MMM-YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
declare function openconfirmationModel(): void;

@Component({
    selector: 'app-taxforms',
    templateUrl: './taxforms.component.html',
    styleUrls: ['./taxforms.component.css'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, CommonModule, MatRadioModule]
})
export class TaxformsComponent implements OnInit {
  @Input() formName: string = '';
  @Input() selYear: string = '';
  @Input() currentType: string = ''; // Add this new input property
  @Input() cycleId: string = ''; // Add this new input property
  fileByte: string = '';
  formData: any = {}; // Initialize formData
  dob_user:any;
  newForm:boolean = false;
  validDob: boolean = true;
  @Output() onSubmit = new EventEmitter();
  @Output() pageName = new EventEmitter();
  @Output() scrollOnLoad = new EventEmitter();
  strVerifyResponse:Record<string, any>={};
  strErrorMessage:string="";
  strSuccessMessage:string="";
  strFileSizeError:string="";
  calendarHeader = CalendarHeaderEditProfile;
  document: { documentType: string, documntName: string, fileBytes: string, filename: string } = {
    documentType: "", documntName: "", fileBytes: "", filename: ""
  };
  valFlag: Record<string, boolean> = {
    estimatedtotalincome: true,
    latestassessment_year: true,
    panCopyRequired: true,
    assessedunder1961act: true,
    taxsection: true,
  };
  StrErrorMessages: {
    aggregate_amount: string,
    amountofincome: string,
    assessedunder1961act: string,
    estimatedincome: string,
    estimatedtotalincome: string,
    latestassessment_year: string,
    natureofincome: string,
    taxsection: string,
    totalforms_number: string
  } = {
      aggregate_amount: '',
      amountofincome: '',
      assessedunder1961act: '',
      estimatedincome: '',
      estimatedtotalincome: '',
      latestassessment_year: '',
      natureofincome: '',
      taxsection: '',
      totalforms_number: ''
    };
  pageLoad: boolean = true;
  disableSubmit:boolean = true;
  decCheck:boolean=false;
  formDataToSubmit:Record<string, any>={};
  confirmationPopup:boolean=false;
  @Input() cycleFlag:boolean=false;
  @Input() cycleName:string='';
  @Input() windowFlag:boolean=false;
  UINNumber: any = '';
  enableSubmitFlag:boolean=false;
  primaryName:string='';
  fullName:string='';
  headerData: any;
  financiarDate:string="";
  headersData:{assessment_year:string,createdby:string,createdby_date:string,cycle_description:string,
  cycle_id:string,cycle_name:string,isactive:string,window_start:string,window_end:string}[]=[];
  blnEnableField: boolean=false;
  taxregime='';
  isnewtax:boolean=false;
  isoldtax:boolean=false;
  cutoffDate: Date;
  switchLogicFlag=false;
  isAge60OrMore: string = '';
  thresholdExceededPopup: boolean = false;
  thresholdExceededMessage: string = '';
  thresholdExceeded: boolean = false;
  panFileSizeError: string = '';
  panFileTypeError: string = '';
  panFileNameError: string = '';
  panDocument: { fileBytes: string, filename: string } = { fileBytes: '', filename: '' };
  blnPanLoading: boolean = false;
  itrFiled: string = '';
  itrDetails: {taxYear: string, acknowledgementNumber: string, returnIncome: string}[] = [
    {taxYear: '', acknowledgementNumber: '', returnIncome: ''},
    {taxYear: '', acknowledgementNumber: '', returnIncome: ''}
  ];
  itrTaxYearOptions: string[] = [
   'FY 2025-26', 'FY 2024-25', 'FY 2023-24', 'FY 2022-23'
  ];
  //cutoffDate: Date = new Date(new Date().setFullYear(new Date().getFullYear() - 60));

  // @Input() selYear:string;
  //startDate:Date;
  //private telemetryService:TelemetryService
  //constructor(private telemetryService:TelemetryService,private investorService : InvestorService, private vps : ViewportScroller) { }
constructor(private investorService : InvestorService, private vps : ViewportScroller, private router: Router) {  
    //dynamic code added as per logic
    const currentYear = new Date().getFullYear();
    const baseYear = 1966; // Starting year for the cutoff
    this.cutoffDate = new Date(`${baseYear + (currentYear - 2025)}-04-01`);
  }

  ngOnInit() {
    //this.startDate= new Date('31-Mar-1945');
   if(environment.telemetryFlg){
     /* let impressionEventData = {
        type: IMPRESSIONEVENTS.FORM,
        pageid: Appconstants.taxFormsPageId,
        uri: window.location.href
      };*/
     // this.telemetryService.impression(impressionEventData);
    }
    this.formData.latestassessment_year = ''; // or any default value 
    console.log(this.formName);
    console.log('Received currentType:', this.currentType); // You can now use currentType
    console.log('Received cycleId:', this.cycleId); // You can now use cycleId
    this.setNatureOfIncome(); // Set initial nature of income
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      if (property === 'formName') {
        console.log('Previous:', changes[property].previousValue);
        console.log('Current:', changes[property].currentValue);
      }
    }  
    
    // Add null check before accessing currentValue
    if (changes['formName'] && changes['formName'].currentValue) {
      this.formName = changes['formName'].currentValue;
      this.document.documentType = this.formName;
      
      // Add null check for cycleId
      if (changes['cycleId'] && changes['cycleId'].currentValue) {
        this.cycleId = changes['cycleId'].currentValue;
      }
      
      this.getHeader();
      this.consentFormChange();
      this.getFormData();
    }
  
    console.log("onChange",this.formName,this.document.documentType);

    if (changes['currentType'] && changes['currentType'].currentValue) {
      console.log('Current type changed:', changes['currentType'].currentValue);
      this.setNatureOfIncome();
    }
  }

  onSelectionChange(event: any) {
  //  alert(event.value)
    this.taxregime = event.value;
    this.isnewtax=this.taxregime=="NewTaxRegime"?true:false;
    this.isoldtax=this.taxregime=="OldTaxRegime"?true:false;
   // console.log("taxregime",this.taxregime);
  }

  onAge60Change(event: any) {
    this.isAge60OrMore = event.value;
    if (this.isAge60OrMore !== 'Yes') {
      this.panDocument = { fileBytes: '', filename: '' };
      this.panFileSizeError = '';
    }
    this.valFlag.panCopyRequired = true;
  }

  deletePanCopy() {
    this.blnPanLoading = true;
    this.panDocument = { fileBytes: '', filename: '' };
    this.panFileSizeError = '';
    this.panFileTypeError = '';
    this.panFileNameError = '';
    this.valFlag.panCopyRequired = false;
    // Reset the native file input so the file name is cleared from the UI
    const fileInput = document.getElementById('panCopyUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.blnPanLoading = false;
  }

  attachPanFile(target: any) {
    const maxSize = 5 * 1024 * 1024;
    const allowedExtensions = /\.(png|jpeg|jpg|pdf|tiff)$/i;
    const fileName = target['files'][0]['name'];
    const fileSize = target['files'][0]['size'];
    let hasError = false;

    // File name length validation
    if (fileName.length > 100) {
      this.panFileNameError = 'File name must not exceed 100 characters.';
      hasError = true;
    } else {
      this.panFileNameError = '';
    }
    
    // File type validation
    if (!allowedExtensions.test(fileName)) {
      this.panFileTypeError = 'Invalid file type. Allowed file types are .png, .jpeg, .jpg, .pdf, .tiff';
      hasError = true;
    } else {
      this.panFileTypeError = '';
    }

    // File size validation
    if (fileSize > maxSize) {
      this.panFileSizeError = 'You are not allowed to upload files more than 5MB. Please reduce file size and try to upload again.';
      hasError = true;
    } else {
      this.panFileSizeError = '';
    }

    if (hasError) {
      target.value = '';
      this.panDocument.fileBytes = '';
      this.panDocument.filename = '';
      this.valFlag.panCopyRequired = false;
      return;
    }

    this.blnPanLoading = true;
    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(target['files'][0]);
    fileReader.onloadend = (e) => {
      this.panDocument.fileBytes = (fileReader.result as string).split(',')[1];
      this.panDocument.filename = target['files'][0]['name'];
      this.valFlag.panCopyRequired = true;
      this.blnPanLoading = false;
    };
    fileReader.onerror = () => {
      this.blnPanLoading = false;
    };
  }

  downloadPanCopy() {
    if (this.panDocument.fileBytes && this.panDocument.filename) {
      const extension = this.panDocument.filename.split('.').pop()?.toLowerCase();
      let mimeType = 'application/octet-stream';
      if (extension === 'pdf') mimeType = 'application/pdf';
      else if (extension === 'png') mimeType = 'image/png';
      else if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';
      else if (extension === 'tiff') mimeType = 'image/tiff';

      const byteCharacters = atob(this.panDocument.fileBytes);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.panDocument.filename;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
  
 
  getFormData() {
    this.investorService.getForm15(this.formName,this.selYear,this.cycleName).subscribe((data) => {
     //this.taxregime=data['taxregime'];
     
      this.formData = data;
    
      this.pageLoad = false;
      if(this.formName ==='Form 15G' || this.formName === 'Form 121 (erstwhile Form 15G Or 15H)'){
        let currentDate = new Date();
        let recordDate = new Date(environment.recordDate);
        if((this.windowFlag || data['enable_submit'].toLowerCase()=="y") && currentDate >= recordDate){
          this.blnEnableField=true;
        }
        else{
          this.blnEnableField=false;
        }
      }
      if(data['enable_submit']?.toLowerCase()=="y" && this.windowFlag==false){
        this.windowFlag=true;
      }
      this.scrollOnLoad.emit(true);
      this.UINNumber=this.formData['identification_number'];
      this.primaryName = this.formData['assessee_name'];
      // if(this.formData['taxregime']!=null && this.formData['taxregime']!=''){
      // this.formData['taxregime'] = this.taxregime;    
      // }
      this.fullName=this.primaryName;
      
      let str = this.formData['assessee_name'];
      let strWS = str.replace(' ','');
      if (str.length >= 6) {
        this.primaryName = strWS.substring(0,3) + 'X'.repeat(strWS.length-6) + strWS.substring(strWS.length-3,strWS.length);
      }
      if(this.formData['form_id']==null || this.formData['form_id']==''){
        this.newForm = true;
        this.formData['form_type'] = this.formName;
        this.formData['natureofincome'] = this.getNatureOfIncome(); // Use dynamic value
        this.formData['taxsection']="393"; // 393  for 121 form we have updated taxsection value as per discussion with tax team
        this.formData['amountofincome']=0;
        this.formData['declaration'] = "I hereby provide consent";
        this.dob_user="";
        this.isoldtax=true;
        this.taxregime="NewTaxRegime";
        // NEW: Set defaults for Form 121 new fields
        if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
          this.isAge60OrMore = '';
          this.itrFiled = '';
          this.itrDetails = [
            {taxYear: '', acknowledgementNumber: '', returnIncome: ''},
            {taxYear: '', acknowledgementNumber: '', returnIncome: ''}
          ];
          this.panDocument = { fileBytes: '', filename: '' };
          this.panFileSizeError = '';
        }
      }
      else{
        this.newForm = false;
        this.valFlag['assessedunder1961act'] = true;
        this.valFlag['taxsection'] = true;
        this.formData['natureofincome'] = this.getNatureOfIncome(); // Use dynamic value
        this.formData['taxsection']="393";  // 393  for 121 form we have updated taxsection value as per discussion with tax team
        this.formData['amountofincome']=0;
        let date= this.formData['dob_user'];

        
        
        if(date!="" && date!=null && date!=undefined){
          this.dob_user=moment(this.fnDateInitial(date as any));
        }
        else{
          this.dob_user="";
        }
        console.log("dob",this.dob_user);
        this.isnewtax=this.formData['taxregime'] == "NewTaxRegime"?true:false;
        this.isoldtax=this.formData['taxregime'] =="OldTaxRegime"?true:false;
        this.taxregime=this.formData['taxregime'];
        // NEW: Pre-populate Form 121 fields from service response
        if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
          this.isAge60OrMore = this.formData['isAge60OrMore'] || '';
          this.itrFiled = this.formData['itrFiled'] || '';
          if(this.formData['itrDetails'] && this.formData['itrDetails'].length > 0){
            this.itrDetails = this.formData['itrDetails'];
          } else {
            this.itrDetails = [
              {taxYear: '', acknowledgementNumber: '', returnIncome: ''},
              {taxYear: '', acknowledgementNumber: '', returnIncome: ''}
            ];
          }
          if(this.formData['panCopyFileBytes'] && this.formData['panCopyFileBytes'] !== ''){
            this.panDocument.fileBytes = this.formData['panCopyFileBytes'];
            this.panDocument.filename = this.formData['panCopyFilename'] || '';
            this.valFlag.panCopyRequired = true;
          } else {
            this.panDocument = { fileBytes: '', filename: '' };
          }
          this.panFileSizeError = '';
        }
      }
    },
    err => {
      console.log(err);
   
    })
  }

  consentFormChange(){
    this.decCheck=false;
    this.disableSubmit = true;
    this.strErrorMessage="";
    this.thresholdExceededPopup=false;
    this.thresholdExceededMessage="";
    this.thresholdExceeded=false;
   
  }

  confirmation(value:string){
        if(value=='OK'){
          this.confirmationPopup=false;
          // After existing form confirmation, check if threshold warning needs to show
          if(this.thresholdExceeded){
            this.thresholdExceededPopup = true;
            return;
          }
          this.finalPostModelSubmit();
         }
        else{
          this.confirmationPopup=false;
          return;
        }
    }

  thresholdConfirmation(value:string){
    if(value=='OK'){
      this.thresholdExceededPopup=false;
      this.formDataToSubmit['thresholdExceeded'] = true;
      this.finalPostModelSubmit();
    }
    else{
      this.thresholdExceededPopup=false;
    }
  }

    fnDateInitial(dateFromModel: string): number[] {
      let formattedDateArray: number[] = [];
      let formattedDate: string[];
      let year: number;
      let month: number;
      let date: number;
      if (dateFromModel !== "" && dateFromModel!=null && dateFromModel!=undefined) {
        formattedDate = dateFromModel.split("-");
        if (formattedDate.length > 0) {
          date = Number(formattedDate[0]);
          year = Number(formattedDate[2]);
          month = this.getMonth(formattedDate[1]);
          formattedDateArray = [year, month, date];
        }
      }
      return formattedDateArray
    }
    getHeader(){
      this.investorService.getHeader().subscribe((data)=>{
        console.log('getHeader',data);      
        this.headerData = data;
        this.pageLoad = false;   
      
        for(let i in this.headerData['cycle_details']){
          console.log('loopingheaderdata',this.headerData['cycle_details'][i]);  
          this.headersData.push({assessment_year:this.headerData['cycle_details'][i]['assessment_year'],
          createdby:this.headerData['cycle_details'][i]['createdby'],
          createdby_date:this.headerData['cycle_details'][i]['createdby_date'],
          cycle_description:this.headerData['cycle_details'][i]['cycle_description'],
            cycle_id:this.headerData['cycle_details'][i]['cycle_id'],
            cycle_name:this.headerData['cycle_details'][i]['cycle_name'],
            isactive:this.headerData['cycle_details'][i]['isactive'],
            window_start:this.headerData['cycle_details'][i]['window_start'],
            window_end:this.headerData['cycle_details'][i]['window_end']})
        }     
      
        console.log("this.headersData",this.headersData);      
        console.log(this.headersData.filter(x => x.isactive  === "1")[0]['cycle_name']);
        console.log(this.headersData.filter(x => x.isactive  === "1")[0]['cycle_description']);   
        let dates =this.headersData.filter(x => x.isactive  === "1")[0]['cycle_name'].split("-");
        console.log(dates);  
        let month  = Number (dates[1]) -60;  
  this.financiarDate= month+"-04-01";
  console.log('this.financiarDate',this.financiarDate)
      },
      err => {
        console.log(err);
        this.pageLoad = true;
      })
    }
    
  getMonth(month: string): number {
    let value: number = 0;
    switch (month) {
      case 'Jan': {
        value = 0;
        break;
      }
      case 'Feb': {
        value = 1;
        break;
      }
      case 'Mar': {
        value = 2;
        break;
      }
      case 'Apr': {
        value = 3;
        break;
      }
      case 'May': {
        value = 4;
        break;
      }
      case 'Jun': {
        value = 5;
        break;
      }
      case 'Jul': {
        value = 6;
        break;
      }
      case 'Aug': {
        value = 7;
        break;
      }
      case 'Sep': {
        value = 8;
        break;
      }
      case 'Oct': {
        value = 9
        break;
      }
      case 'Nov': {
        value = 10
        break;
      }
      case 'Dec': {
        value = 11
        break;
      }
    }
    return value;
  }

  convertFileToByte(file: File) {
    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = (e) => {
      console.log(e);
      this.fileByte = fileReader.result as string;
      this.fileByte = this.fileByte.split(',')[1];
      this.document.fileBytes = this.fileByte;
      this.document.filename = file.name;
      console.log("totalfiles", this.fileByte);
    };
  }

  validateType(type: string, name: string): boolean {
    // let accept = ['application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint',
    //   'text/plain',' application/pdf', 'image/*'];
    // .xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
    // let re =/(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.txt|\.xlsx|\.xls)$/
    let re =/(\.pdf)$/

    if( type.match('image/*')){
      return true;
    }
    else if(re.exec(name)){
      return true;
    }
    else {
      return false;
    }
  }

  attachFile(target: any) {
    console.log("target", target['files']);
    
    // Check file size (5MB = 5 * 1024 * 1024 bytes)
    const maxSize = 5 * 1024 * 1024;
    if (target['files'][0]['size'] > maxSize) {
      this.strFileSizeError = 'You are not allowed to upload files more than 5MB. Please reduce file size and try to upload again.';
      target.value = '';
      this.document['fileBytes'] = '';
      this.document['filename'] = '';
      return;
    }
    
    // Clear file size error if valid
    this.strFileSizeError = '';
    
    if (this.validateType(target['files'][0]['type'],target['files'][0]['name'])) {
      this.convertFileToByte(target['files'][0]);
    }
    else {
      console.log("invalid file");
      this.document['fileBytes'] = '';
      this.document['filename'] = '';
    }
  }
  
  
  checkConsent(event: any){
    if(event.target.checked){
      this.decCheck=true;
      console.log("incheck");
       this.disableSubmit = false;
    }
    else{
      this.decCheck=false;
      console.log("not check");
      this.disableSubmit = true;
      
    }
  }

  fnTakeAction(form: NgForm) {
   // alert ("in take action"+this.taxregime);
    let dobSubmit: string;
    let arrFromDate: string[];
    let strfinalDOB: string;
    let totalincome:number=1200000;
    let aggreggate:number=400000;
    // Reset threshold state at start to prevent stale state
    this.thresholdExceededPopup = false;
    this.thresholdExceededMessage = '';
    this.thresholdExceeded = false;
    // this.formData['estimatedincome']!=null&&this.formData['estimatedincome']!=''?this.valFlag.estimatedincome=true:this.valFlag.estimatedincome=false;
    
    //  if(this.formData['estimatedincome']!=null&&this.formData['estimatedincome']!=''){
        
    //    if(this.formData['estimatedincome']<0 ){
    //       this.strErrorMessage = "Estimated income should be greater than zero";
    //       return;
    //    }
    //     if((this.formData['dividend_amt']+this.formData['prev_dividend_amt'])>250000  && this.formName == "Form 15G"){
    //         this.strErrorMessage = "Estimated income should not exceed 2,50,000.";
    //         return;
    //     }
     
     
    //   }
    if(this.taxregime == 'OldTaxRegime'){
      totalincome = 500000;
      aggreggate= 250000;
    }

    this.formData['estimatedincome']=(this.formData['dividend_amt']+this.formData['prev_dividend_amt'])>250000?250000:(this.formData['dividend_amt']+this.formData['prev_dividend_amt']);


   if(this.switchLogicFlag){
      this.formData['latestassessment_year']!=null&&this.formData['latestassessment_year']!=''?this.valFlag.latestassessment_year=true:this.valFlag.latestassessment_year=false;
      if(this.formData['latestassessment_year']==null || this.formData['latestassessment_year']==''){
          this.strErrorMessage = "Please fill all the required fields.";
          this.scroll('top');
          return;
      }
    }else
    {
       this.valFlag.latestassessment_year=true
    }
   
    this.formData['estimatedtotalincome']!=null&&this.formData['estimatedtotalincome']!=''?this.valFlag.estimatedtotalincome=true:this.valFlag.estimatedtotalincome=false;
   // this.formData['estimatedtotalincome']>0 ?this.valFlag.estimatedtotalincomeNegative=true:this.valFlag.estimatedmincomeNegative=false;

    if(this.formData['estimatedtotalincome']!=null&&this.formData['estimatedtotalincome']!=''){
      if(this.formData['estimatedtotalincome']<0)
      {
        this.strErrorMessage = "Estimated Total income should be greater than zero.";
        this.scroll('top');
        return;
      }
      if(this.formData['estimatedtotalincome']>totalincome && this.formData['estimatedtotalincome']!= totalincome){    
        this.strErrorMessage = "Estimated Total income should not exceed "+totalincome.toLocaleString('en-IN')+".";
        this.scroll('top');
        return;
      }
    }
    
    if(this.formName == "Form 15G"){
      if((this.formData['aggregate_amount']) > aggreggate && (this.formData['aggregate_amount']) != aggreggate ){
        this.strErrorMessage = "Estimated income and Aggregate income should not exceed "+aggreggate.toLocaleString('en-IN')+".";
        this.scroll('top');
        return;
      }
       let incomesum:number=400000;
       if(this.taxregime == 'OldTaxRegime'){
         incomesum=250000;
       }
      if((this.formData['aggregate_amount'] +this.formData['estimatedincome']) > incomesum){
        this.strErrorMessage = "Estimated income and Aggregate income should not exceed "+incomesum.toLocaleString('en-IN')+".";
        this.scroll('top');
        return;
      }
    }
   // Form 121 aggregate and combined income validations
    if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
      let incomesum121:number=400000;
      let regimeLabel:string = 'New Tax Regime';
      if(this.taxregime == 'OldTaxRegime'){
        incomesum121=250000;
        regimeLabel = 'Old Tax Regime';
      }

      // Aggregate income validation: only for age < 60 (no capping for age >= 60)
      if(this.isAge60OrMore !== 'Yes'){
        if((this.formData['aggregate_amount']) > incomesum121 && (this.formData['aggregate_amount']) != incomesum121 ){
          this.strErrorMessage = "Aggregate income of other Form 121 filed should not exceed INR "+incomesum121.toLocaleString('en-IN')+" under "+regimeLabel+".";
          this.scroll('top');
          return;
        }
      }

      // Combined sum threshold check moved to after all validations pass
    }
    
    // ITR Details validation for Form 121
    if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
      if(this.itrFiled === ''){
        this.strErrorMessage = "Please select whether Income Tax Returns were filed for previous two tax years.";
        this.scroll('top');
        return;
      }
      if(this.itrFiled === 'Yes'){
        for(let i = 0; i < this.itrDetails.length; i++){
          let row = this.itrDetails[i];
          if(!row.taxYear || !row.acknowledgementNumber || row.returnIncome === '' || row.returnIncome === null || row.returnIncome === undefined){
            this.strErrorMessage = "Please fill all ITR details for Sl. No  " + (i + 1) + ". Tax Year, Acknowledgement Number and Return Income are required.";
            this.scroll('top');
            return;
          }
          if(!/^\d+$/.test(row.acknowledgementNumber)){
            this.strErrorMessage = "Acknowledgement Number in Sl. No  " + (i + 1) + " must contain only numbers.";
            this.scroll('top');
            return;
          }
          if(isNaN(Number(row.returnIncome))){
            this.strErrorMessage = "Return Income in Sl. No  " + (i + 1) + " must be a valid number.";
            this.scroll('top');
            return;
          }
        }
        // Duplicate tax year validation
        if(this.itrDetails[0].taxYear && this.itrDetails[1].taxYear && this.itrDetails[0].taxYear === this.itrDetails[1].taxYear){
          this.strErrorMessage = "Tax Year for Sl. No  1 and Sl. No  2 cannot be the same. Please select different tax years.";
          this.scroll('top');
          return;
        }
      }
    }

    // Age 60+ and PAN copy validation for Form 121
    if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
      if(this.isAge60OrMore === ''){
        this.strErrorMessage = "Please select whether age is 60 years or more at any time during the tax year.";
        this.scroll('top');
        return;
      }
      if(this.isAge60OrMore === 'Yes' && this.panDocument.fileBytes === ''){
        this.valFlag.panCopyRequired = false;
        this.strErrorMessage = "Please attach PAN copy.";
        this.scroll('top');
        return;
      }
    }

    // Form 121 combined sum threshold check (estimated income + aggregate income)
    // For users below 60: show popup warning but ALLOW submission after acknowledgement
    // For users 60+: no capping, allow submission directly
    if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
      if(this.isAge60OrMore !== 'Yes'){
        let incomesum121:number=400000;
        if(this.taxregime == 'OldTaxRegime'){
          incomesum121=250000;
        }
        let totalSum = (this.formData['aggregate_amount'] || 0) + this.formData['estimatedincome'];
        if(totalSum > incomesum121){
          if(this.taxregime == 'OldTaxRegime'){
            this.thresholdExceededMessage = "Please note that the total of the Estimated income for this declaration and aggregate income of other Form 121 filed for other entities has exceeded the basic exemption limit of INR 2,50,000. Thus, the form will be considered invalid.";
          } else {
            this.thresholdExceededMessage = "Please note that the total of the Estimated income for this declaration and aggregate income of other Form 121 filed for other entities has exceeded the basic exemption limit of INR 4,00,000. Thus, the form will be considered invalid.";
          }
          this.thresholdExceeded = true;
        }
      }
    }

    this.strErrorMessage="";

    const flagarray = Object.keys(this.valFlag);
    
    console.log("flag",flagarray);

    let flg = true;
    flagarray.map(flag=>{
      flg = flg&&this.valFlag[flag];
    })
    if(!flg){
      this.strErrorMessage = "Please fill all the required fields.";
      this.scroll('top');
      return;
    }
   
    if(this.formName == "Form 15H" ){
      //this.checkDob(form.value['dob_user']); 
      console.log(form.value['dob_user']);
      if(form.value['dob_user']=="" || form.value['dob_user']==null || form.value['dob_user']==undefined)
      {
      this.validDob = false;
      this.strErrorMessage = "Please enter date of birth.";
      this.scroll('top');
      return;
      }
    }
   
    const allowed = ['aggregate_amount',
    'dividend_amt',
    'amountofincome',
    'assessedunder1961act',
    'assessee_name',
    'declaration',
    'estimatedincome',
    'estimatedtotalincome',
    'form_id',
    'form_type',
    'identification_number',
    'latestassessment_year',
    'natureofincome',
    'previousyear',
    'status_user',
    'taxsection',
    'totalforms_number',
    'dob_user',
    'taxregime'
  ];


    this.formDataToSubmit = Object.keys(this.formData)
      .filter(key => allowed.indexOf(key)!=-1)
      .reduce<Record<string, any>>((obj, key) => {
        obj[key] = this.formData[key];
        return obj;
      }, {});

      if(this.formName == "Form 15H" ){
        let dobSubmit=form.value['dob_user']['_d'];
        arrFromDate =  dobSubmit.toString().split(" ");
        strfinalDOB = arrFromDate[2] + '-' + arrFromDate[1] + '-' + arrFromDate[3];
        this.formDataToSubmit['dob_user']= strfinalDOB;
      }
      this.formDataToSubmit['taxregime'] = this.taxregime;
      if(this.formName == "Form 121 (erstwhile Form 15G Or 15H)"){
        this.formDataToSubmit['itrFiled'] = this.itrFiled;
        if(this.itrFiled === 'Yes'){
          this.formDataToSubmit['itrDetails'] = this.itrDetails;
        }
        this.formDataToSubmit['isAge60OrMore'] = this.isAge60OrMore;
        if(this.isAge60OrMore === 'Yes'){
          this.formDataToSubmit['panCopyFileBytes'] = this.panDocument.fileBytes;
          this.formDataToSubmit['panCopyFilename'] = this.panDocument.filename;
        }
        this.formDataToSubmit['totalAggIncome'] = this.formData['estimatedincome'] + (this.formData['aggregate_amount'] || 0);
      }
      console.log("formDataToSubmitafter", this.formDataToSubmit);
      this.formDataToSubmit['cycleId'] = this.cycleId;

    if(this.newForm==false){
      this.confirmationPopup=true;
      openconfirmationModel();
      
    }
     else if(this.thresholdExceeded){
      // Show threshold warning popup - user must acknowledge before submission proceeds
      this.thresholdExceededPopup = true;
     }
     else{
      this.finalPostModelSubmit();
     }
   

    
  }

  finalPostModelSubmit(){
    this.pageLoad =true;
    console.log("emiitt");
      this.disableSubmit = true;
      
    this.investorService.uploadForm(this.formDataToSubmit).subscribe(data => {
      this.strVerifyResponse= data as Record<string, any>;
      console.log("output",  this.strVerifyResponse);
      if (this.strVerifyResponse['code'] == "1") {
        this.pageLoad = false;     
        this.strSuccessMessage = this.strVerifyResponse['message'];
         this.pageName.emit('RESIDENT');  
        if(environment.telemetryFlg){
        let telemetryEventData = {
          type: INTERACTEVENTS.CLICK,
          id: this.formName +" "+ Appconstants.success,
          pageid: Appconstants.taxFormsPageId
        }
        //this.telemetryService.interact(telemetryEventData);
     }
        //this.strSuccessMessage = this.strVerifyResponse['message'];
        this.strErrorMessage = '';
       
        //this.pageLoad = false;
       // this.pageName.emit('RESIDENT');
      }
      else{
        this.strErrorMessage=this.strVerifyResponse['message'];
        this.pageLoad = false;
        if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.error +" "+ this.strErrorMessage ,
            pageid: Appconstants.taxFormsPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
      }
        setTimeout(() => {
        this.strErrorMessage = "";
        }, 3000);
     
      }
       this.disableSubmit = false;
    },err=>{
      console.log(err);
      this.strErrorMessage="Some Error Occured, Please try later.";
      this.pageLoad = false;
      this.disableSubmit = false;
        if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.failure +" "+ err ,
            pageid: Appconstants.taxFormsPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
      }
      setTimeout(() => {
        this.strErrorMessage = "";
        }, 3000);
     
    });
  }

  // checkDob(dob: Date) {
  //   console.log("checkDob", dob);
  //   var entereddate= new Date(dob).toLocaleString();
  //   var finalDate=  this.fnDateConversion(entereddate);
  //   if(new Date(finalDate) <= new Date('3-31-1961') || new Date(finalDate) <= new Date('31-Mar-1961')){
  //     this.validDob = true;
  //   }
  //   else {
  //     this.validDob = false;
  //   }


  // }

  fnDateConversion(planDate:string){
    var dateSplit= planDate.split(',');
    var datePart= dateSplit[0].split('/');
    return datePart[0]+"-"+datePart[1]+"-"+datePart[2];
   
  
  }

  scroll(id: string) {
     const element = document.getElementById(id);
    if (element) {
      const topOffset = 180;
      const y = element.getBoundingClientRect().top + window.pageYOffset - topOffset;
      window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
      return;
    }
    this.vps.scrollToAnchor(id);
  }

  reset(){
    //this.getFormData();
    // this new function will navigate user back to the list page with the current type (dividend or buyback) as query param, where they can select to create a new form or edit existing forms. This is to ensure that the URL is updated correctly and the user can refresh the page without losing context.
      window.location.href = '/app-home/investor/thingstodo?type=' + (this.currentType || 'dividend');
  }

  // Add this new method
  getNatureOfIncome(): string {
    if (this.currentType === 'buyback') {
      return 'Dividend';  // we need to bind the same value “dividend” for both cases of dividend/buyback.
    } else if (this.currentType === 'dividend') {
      return 'Dividend';
    }
    // Default fallback
    return 'Dividend';
  }

  // Add this new method
  setNatureOfIncome(): void {
    if (this.formData) {
      this.formData.natureofincome = this.getNatureOfIncome();
    }
  }

  // Add this new method
  getIncomeTypeText(): string {
    if (this.currentType === 'buyback') {
      return '';
    } else if (this.currentType === 'dividend') {
      return 'Dividend';
    }
    // Default fallback
    return 'Dividend';
  }

onAckNumberPaste(event: ClipboardEvent, index: number) {
    const pastedData = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }

onChangeassessmentyr(event: any){
 // alert(event.target.value)
  //console.log("event",event);
  if(this.switchLogicFlag){
    if(event.target.value!==null && event.target.value!=undefined && event.target.value!=''){
        this.valFlag.latestassessment_year=true;
        //this.formData['latestassessment_year']=event.target.value;  
      }
      else{
        this.valFlag.latestassessment_year=false;
      }
  }else
  {
      this.valFlag.latestassessment_year=true;
  }
  
  //event.target.value!=''?this.valFlag.latestassessment_year=true:this.valFlag.latestassessment_year=false
}

switchLogic(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (this.formData) {
      this.formData.assessedunder1961act = checked ? 'yes' : 'no';
    }
    if(checked){
      this.switchLogicFlag=true;
      if(this.formData['latestassessment_year']==null || this.formData['latestassessment_year']==''){
        this.valFlag.latestassessment_year=false;
        return;
       }
       else
       {
        this.valFlag.latestassessment_year=true;
       }
    }
    else
    { this.switchLogicFlag=false;
      this.valFlag.latestassessment_year=true;
    }
    // additional logic on change can be added here
  }
}



@Component({
    selector: 'calendar-header',
    styles: [`
    .calendar-header {
      display: flex;
      align-items: center;
      padding: 0.5em;
    }

    .calendar-header-label {
      flex: 1;
      height: 1em;
      font-weight: 500;
      text-align: center;
    }

    .calendar-double-arrow .mat-icon {
      margin: -22%;
    }
  `],
    template: `
    <div class="calendar-header">
      <button mat-icon-button class="calendar-double-arrow" (click)="previousClicked('year')">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="calendar-header-label">{{periodLabel}}</span>
      <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <button mat-icon-button class="calendar-double-arrow" (click)="nextClicked('year')">
        <mat-icon>keyboard_arrow_right</mat-icon>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  `,
    standalone: false
})
export class CalendarHeaderEditProfile<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

   constructor( 
    private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats, cdr: ChangeDetectorRef) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    return this._dateAdapter
      .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
      .toLocaleUpperCase();
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }

  // window is open or not prfile service

}